<template>
  <div>
    <div class="example" v-if="oturum_is_loaded === false">
      <nodatayet v-if="noDataYet === true"></nodatayet>
      <div v-else>
        <b-button class="ml-3 d-flex" variant="outline-primary">
          <b-icon icon="arrow-clockwise" @click="refreshBtn"></b-icon>
        </b-button>
        <apexchart
            height="450px"
            ref="donut"
            :options="chartOptions"
            :series="series"
        ></apexchart>
      </div>
    </div>
    <loading v-else></loading>
  </div>
</template>


<script>
import ApexCharts from 'vue-apexcharts'
import loading from "@/components/LoadingSpiner";
import nodatayet from "@/components/NoDataYet";
import axios from "axios";

export default {
  name: 'DonutExample',
  components: {
    apexchart: ApexCharts,
    loading,
    nodatayet
  },
  props: ['y_mesaj'],
  data() {
    return {
      noDataYet: true,
      oturum_is_loaded: true,
      //response verilerini tutacak degiskenler
      response: null,
      x_axis_data: [],
      saat: [],
      //apex chart degiskenleri
      series: [{
        name: 'series-1',
        data: null,
      }],
      noData: {
        text: "Loading..."
      },
      chartOptions: {
        series: null,
        chart: {
          type: 'bar',
          zoom: {
            type: 'xy',
            autoScaleYaxis: false,
            zoomedArea: {
              fill: {
                opacity: 0.4
              }
            },
            stroke: {
              width: '30px'
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: 90,
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transperan']
        },
        colors: ['#8B008B'],
        xaxis: {
          max: '90%',
          labels: {
            router: -45
          },
          categories: [],
          tickPlacement: 'on'
        },
        yaxis: {
          title: {
            text: this.y_mesaj,
          },
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {}
        }
      },
    }
  },

  created() {
    this.oturumRaporunuGetir()
  },

  methods: {
    refreshBtn() {
      this.oturumRaporunuGetir()
    },
    async oturumRaporunuGetir() {
      this.oturum_is_loaded = true
      try {
        this.response = await axios.get('rapor/olusacak-oturum/', {
          baseURL: "https://bbbservis.hayrategitim.com/api/"
        })
        if (this.response.data === null) {
          this.noDataYet = true
          this.oturum_is_loaded = false
          return
        }
        this.noDataYet = false
        this.oturumAdedi()
      } catch (e) {
        this.showErrorMessageToast(e)
      }
    },
    // gelen resposne ile degiskenlerin icini dolduruyoruz
    async oturumAdedi() {
      this.x_axis_data = []
      this.saat = []
      try {
        const data = this.response.data
        data.forEach((value, index) => {
          this.x_axis_data.push(value.oturum_adedi)
          this.saat.push(value.saat)
        })
        this.series = []
        this.chartOptions.series = []
        this.fill_tahmini_katilimci()
      } catch (e) {
        this.showErrorMessageToast(e)
      }
      this.oturum_is_loaded = false
    },
    //degiskenlerden apex chart icini dolduruyorum
    fill_tahmini_katilimci() {
      this.series = [{
        name: 'Oturum Adedi',
        data: this.x_axis_data,
      }]
      this.chartOptions.xaxis.categories = this.saat
    },
  }
}
</script>